import {ReactNode} from "react";
import {DocumentCategory} from "platformed-client/types";
import T from "platformed-components/i18n/T";

type DocumentCategoryInfo = {text: ReactNode; textPlural: ReactNode; color: string};

export const DOCUMENT_CATEGORY_MAP: {[category in DocumentCategory]: DocumentCategoryInfo} = {
  ["Policy"]: {text: <T keyName="c.Policy" />, textPlural: <T keyName="c.Policies" />, color: "gray"},
  ["Certification"]: {
    text: <T keyName="c.Certification" />,
    textPlural: <T keyName="c.Certifications" />,
    color: "gray",
  },
  ["Other"]: {text: <T keyName="c.Other" />, textPlural: <T keyName="c.Other" />, color: "gray"},
  ["Report"]: {text: <T keyName="c.Report" />, textPlural: <T keyName="c.Reports" />, color: "gray"},
};

export const CATEGORY_TITLES: {[category in DocumentCategory]: ReactNode} = {
  Policy: <T keyName="c.Policies" />,
  Certification: <T keyName="c.Certifications" />,
  Report: <T keyName="c.Reports" />,
  Other: <T keyName="c.Other_documents" />,
};

export const CATEGORY_EMPTY_TEXT: {[category in DocumentCategory]: ReactNode} = {
  Policy: <T keyName="c.No_policies" />,
  Certification: <T keyName="c.No_certifications" />,
  Report: <T keyName="c.No_reports" />,
  Other: <T keyName="c.No_other_documents" />,
};

export const ACTIVE_CATEGORIES = ["Policy", "Certification", "Other"] satisfies DocumentCategory[];
